<template>
  <div id="app">
    <a-layout-header :style="headerStyle" v-if="menu">
      <!--  @click="showModal" -->
      <div class="header-content">
        <div class="header-logo">
          <img src="./assets/logo.png" alt="">
        </div>
        <div class="header-menu">
          <div class="hader-menu-item">
            <div class="hader-menu-item-title" @click="toPage('/')">无忧首页</div>
            <!-- <div class="hader-menu-item-hover"></div> -->
          </div>
          <div class="hader-menu-item" @mouseenter="showSubMenu" @mouseleave="hideSubMenu">
            <div class="hader-menu-item-title">解决方案
              <a-icon v-if="isSubMenuVisible == false" style="color: #2570f9;" type="caret-down" theme="filled" />
              <a-icon v-else style="color: #2570f9;" type="caret-up" theme="filled" />
            </div>
            <transition name="fade">
              <div class="hader-sub-menus" v-show="isSubMenuVisible" @click.stop>
                <div class="left">
                  <h1>解决方案</h1>
                  <p>为政府，教育，金融，医疗等客户提供产业解决方案</p>
                  <p class="btn">立即获取方案</p>
                </div>
                <div class="right">
                  <h1>解决方案</h1>
                  <div class="sub-model">
                    <div class="sub-model-item">
                      <h1>智慧赋能生产管理</h1>
                      <p>设备维护、销售订单、物料拆分、原料采购、生产计划及实施、质量检测、库存及财务管理，一站式生产管理专家。</p>
                    </div>
                    <div>
                      <h1>无人机系统集成</h1>
                      <p>无人机系统集成旨在优化无人机的性能、扩展其应用领域，并提升整体系统的可靠性和效率。</p>
                    </div>
                    <div>
                      <h1>AI识别解决方案</h1>
                      <p>综合AI智能识别系
                        统解决方案通过整合多种人工智能识别技术，实现对人、物、行为、车辆等多维度的智能化识别和管理。该系统广泛适用于安防监控、智能交通、智慧零售、工业自动化等领域，能够显著提升安全性、运营效率和用户体验。
                      </p>
                    </div>
                    <div>
                      <h1>电池电车解决方案</h1>
                      <p>提供智能能源管理以及相关软件和数据分析服务。</p>
                    </div>
                    <div>
                      <h1>ERP系统解决方案</h1>
                      <p>将企业内部各个部门的业务数据整合到一起，实现数据共享和业务协同，提升企业的运营效率和管理水平。</p>
                    </div>

                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="hader-menu-item">
            <div class="hader-menu-item-title" @click="scrollToSection('content-node2')">精选案例</div>
            <!-- <div class="hader-menu-item-hover"></div> -->
          </div>
          <div class="hader-menu-item" @click="toPage('/news')">
            <div class="hader-menu-item-title">资讯中心</div>
            <!-- <div class="hader-menu-item-hover"></div> -->
          </div>
        </div>
        <div class="header-btn" @click="toPage('/abount')">

          <span> <a-icon type="codepen-circle" style="font-size: 20px;" theme="filled" /><span
              class="txt">提交需求</span></span>
        </div>
      </div>
    </a-layout-header>
    <div v-else class="min-top">
      <div class="min-hander">
        <div class="logo">
          <img src="./assets/logo.png" alt="">
        </div>
        <div class="btn" @click="minSubMenu = !minSubMenu">
          <!-- <a-icon type="codepen-circle" style="font-size: 30px;" theme="filled" /> -->
          <a-icon type="bars" style="font-size: 30px;" />
        </div>
      </div>
      <transition name="fade">
        <div v-show="minSubMenu" class="min-sub-menu">
          <div class="min-sub-menu-item" @click="toPage('/')">无忧首页</div>
          <div class="min-sub-menu-item" @click="scrollToSection('content-node2')">精选案例</div>
          <div class="min-sub-menu-item" @click="toPage('/news')">资讯中心</div>
          <div class="min-sub-menu-item" @click="toPage('/abount')">联系我们</div>
        </div>
      </transition>
    </div>

    <router-view />
    <a-layout-footer :style="{ textAlign: 'center', padding: '0px' }">
      <div class="footer-node">
        <div class="footer-node-1">
          <p class="footer-node-1-title">根据您提交的需求，将有人与您联系，定制专属解决方案</p>
          <a-button type="primary" class="footer-node-1-btn" @click="showModal">
            立即咨询
          </a-button>
        </div>
        <div class="footer-node-2">
          <div class="footer-node-2-menu"></div>
          <div class="footer-node-2-qrCode">
            <div class="footer-node-2-qrCode-item">
              <div class="footer-node-2-qrCode-item-img">
                <img src="./assets/qr01.jpg" alt="">
              </div>
              <div class="footer-node-2-qrCode-item-desc">
                关注公众号
              </div>
            </div>
            <div class="footer-node-2-qrCode-item">
              <div class="footer-node-2-qrCode-item-img">
                <img src="./assets/qr02.jpg" alt="">
              </div>
              <div class="footer-node-2-qrCode-item-desc">
                扫码联系
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-layout-footer>
    <div class="content-node4">
      <a-modal v-model="visible" title="扫码联系" ok-text="确定" cancelText="关闭" @ok="hideModal" style="text-align: center;">
        <img src="./assets/qr02.jpg" />
      </a-modal>
    </div>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      headerStyle: {
        position: 'fixed',
        zIndex: 1,
        width: '100%'
      },
      isSubMenuVisible: false,
      hideTimeout: null,
      menu: true,
      minSubMenu: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    toPage(url) {
      this.minSubMenu = false
      this.$router.push({
        path: url
      })
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      console.log(element)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    // 显示子菜单
    showSubMenu() {
      clearTimeout(this.hideTimeout);
      this.isSubMenuVisible = true;
    },

    // 隐藏子菜单
    hideSubMenu() {
      // 添加一点延迟，避免鼠标意外离开时立即关闭
      this.hideTimeout = setTimeout(() => {
        this.isSubMenuVisible = false;
      }, 300);
    },
    // 点击页面其他区域关闭菜单
    closeMenu(e) {
      if (!e.target.closest('.hader-menu-item')) {
        this.isSubMenuVisible = false;
      }
    },
  },
  mounted() {
    let size = window.innerWidth
    if (size < 768) {
      this.menu = false
    } else {
      this.menu = true
    }
    // 添加全局点击事件监听
    document.addEventListener('click', this.closeMenu);
  },
  // 组件销毁前
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.closeMenu);
  },
}
</script>

<!-- <template> 和 <script> 部分保持不变 -->

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.footer-node {
  background: url("./assets/bg.Du78Z1_B.png") no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  height: 338px;
  overflow: hidden;
  cursor: pointer;

  .footer-node-2 {
    display: flex;
    justify-content: space-around;

    .footer-node-2-qrCode {
      display: flex;
      justify-content: flex-start;

      .footer-node-2-qrCode-item {
        margin-right: 15px;

        .footer-node-2-qrCode-item-desc {
          color: #ffff;
          font-size: 10px;
        }

        .footer-node-2-qrCode-item-img {
          margin-bottom: 10px;

          img {
            width: 73px;
          }
        }
      }
    }
  }

  .footer-node-1 {
    margin-top: 50px;
    margin-bottom: 16px;

    .footer-node-1-btn {
      width: 150px;
      height: 40px;
    }

    .footer-node-1-title {
      font-size: 32px;
      color: #ffff;
      font-weight: 500;
      text-align: center;
    }
  }
}

@media screen and (max-width: 768px) {
  .min-sub-menu {
    text-align: start;
    margin: 0px 10px;

    .min-sub-menu-item {
      border-bottom: 1px #eeeeee solid;
      padding: 10px;
      font-size: 15px;
      font-weight: 500;
    }
  }

  .min-top {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
    background-color: #f6faff;
  }

  .min-hander {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;

    .btn {
      margin: 0px 20px;
      color: #2570f9;
    }

    .logo {
      transform: scale(0.8);

      img {
        width: 150px;
      }
    }
  }

  .item {
    width: 60%;
    margin: 0px auto;
    padding: 80px 0px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .footer-node .footer-node-1 .footer-node-1-title {
    font-size: 12px;
    color: white;
    font-weight: 500;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {

  // 保留可能相关的通用媒体查询规则，如果确定 .ant-layout-header 等未使用也可删除
  .ant-layout-header {
    padding: 0px 0px !important;
  }
}

// Ant Design Vue 组件样式，保留
.ant-layout-header {
  cursor: pointer;
  background: #eff6fc;
}

// Header 相关样式，保留
.header-content {
  margin: 0px auto;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  .header-logo {
    flex-grow: 0.5;
    overflow: hidden;

    img {
      width: 150px;
    }
  }

  .header-btn {
    display: flex;
    align-items: center;

    span {
      background-color: #2570f9;
      display: flex;
      align-items: center;
      height: 32px;
      color: #fff;
      padding: 18px 10px;
      border-radius: 50px;

      .txt {
        // 保留 .txt
        // 可以在这里添加 .txt 特定的样式，如果有的话
      }
    }
  }

  .header-menu {
    height: 64px;
    display: flex;
    flex-grow: 1;

    // 注意：如果确认第二个菜单项不需要这个特殊伪元素，可以删除这个块
    .hader-menu-item:nth-child(2) {
      .hader-menu-item-title::after {
        background: transparent;
        bottom: 16px;
        content: " ";
        height: 2px;
        position: absolute;
        transform: translate(-100%);
        transition: all 1s ease-in-out;
        width: 100px;
      }
    }

    .hader-menu-item {
      padding: 0px 20px;
      line-height: 64px;
      height: 64px;
      position: relative;

      /* Vue Transition 动画类，保留 */
      .fade-enter-active,
      .fade-leave-active {
        transition: all 1s;
      }

      .fade-enter,
      .fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
      }

      .hader-sub-menus {
        // 保留
        position: absolute;
        background: #fff;
        display: flex;
        align-content: center;
        justify-content: start;
        overflow: hidden;
        left: -99px;
        // 添加可能需要的其他基础样式

        .left {
          // 保留
          // 保留 .left 内的样式
          background-image: url("./assets/sub-bg.png"); // 确保路径正确
          background-repeat: no-repeat;
          background-size: cover;

          h1 {
            font-size: 18px;
            line-height: 100%;
            margin-top: 50px;
            font-weight: bold;
          }

          .btn {
            margin-top: 80px;
            text-align: center;
            color: #2570f9;
          }

          p {
            margin-top: 30px;
            padding: 0px 60px;
            font-size: 12px;
            width: 300px;
            line-height: 20px;
            text-align: start;
          }
        }

        .right {
          // 保留
          // 保留 .right 内的样式
          width: 800px; // 可能需要响应式调整

          h1 {
            font-size: 18px;
            line-height: 100%;
            margin-top: 50px;
            font-weight: bold;
            text-align: start;
            padding-left: 10px;
          }

          .sub-model {
            // 保留
            // 保留 .sub-model 内的样式
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 10px 0px;

            // 注意：这里的 div 选择器比较宽泛，如果 .sub-model-item 是实际使用的类，最好用它
            div:hover {
              // 或者使用 .sub-model-item:hover
              transform: translateY(-10px);
            }

            div {
              // 或者使用 .sub-model-item
              // 保留 div 内的样式
              width: 245px;
              transition: all 1s;
              background: linear-gradient(180deg, #fcfcfd 0%, #f6fbfe 100%);
              margin: 10px;

              h1 {
                font-size: 15px;
                font-weight: 400;
                margin: 0px;
                padding: 10px;
              }

              p {
                font-size: 8px;
                line-height: 15px;
                text-align: start;
                padding: 0px 10px;
                padding-right: 54px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                display: -webkit-box;
              }
            }

            .sub-model-item {
              // 保留 .sub-model-item，如果模板中用到了
              // 如果上面的 `div` 样式是给 .sub-model-item 的，可以将样式移到这里
              // 或者确认模板中使用的是 `div` 还是 `.sub-model-item`
            }
          }
        }
      }

      .hader-menu-item-title {
        // 保留
        height: 100%;
        font-size: 18px;
        color: #4e5969;
        text-align: center;
        width: 100%;
        // cursor: pointer; // 鼠标指针已在 .hader-menu-item 上设置

        i {
          margin: 0px 5px;
        }
      }

      // 通用的伪元素下划线效果
      .hader-menu-item-title::after {
        background: transparent;
        bottom: 16px;
        content: " ";
        height: 2px;
        position: absolute;
        transform: translate(-100%);
        width: 72px; // 宽度可能需要根据文字调整
        transition: all 1s ease-in-out;
      }

      .hader-menu-item-title:hover::after {
        color: #2570f9;
        transition: all .1s ease-in-out;
        background-color: #2570f9;
      }

      .hader-menu-item-title:hover {
        color: #2570f9;
        cursor: pointer;
        font-weight: bold;
      }
    }
  }
}
</style>